import TechnicalDifficulties from './TechnicalDifficulties';

export default TechnicalDifficulties;
